import { useEffect, useState } from 'react';
import { Country, getCountries } from '../../api';

const useCountries = (): { countries: Country[], error?: Error, loading: boolean } => {
  const [countries, setCountries] = useState<Country[]>([]);
  const [error, setError] = useState<Error | undefined>();

  useEffect(() => {
    getCountries()
      .then(response => response.sort((a, b) => {
        if (a.nativeName < b.nativeName) { return -1; }
        if (a.nativeName > b.nativeName) { return 1; }
        return 0;
      }))
      .then(setCountries)
      .catch(error => {
        setError(error);
      });
  }, []);

  return { countries, error, loading: countries.length === 0 && !error };
}

export default useCountries;
